import type { Network } from "../types";

export const instagram: Network = {
  name: "Instagram",
  shareUrl: "https://www.instagram.com/share?url=[u]",
  icon: "/media/images/social-share-instagram.png",
  color: "#0866FF",
};
